"use strict";
import { useContext } from "react";
import { Button, Flex, Text, useSporeColors } from "ui/src";
import { AlertTriangleFilled } from "ui/src/components/icons/AlertTriangleFilled";
import { opacify } from "ui/src/theme";
import { Modal } from "components/modals/Modal";
import { getAlertColor } from "components/modals/WarningModal/getAlertColor";
import { WarningSeverity } from "components/modals/WarningModal/types";
import Trace from "features/telemetry/Trace";
import { ElementName } from "features/telemetry/constants";
import { SwapFormContext } from "features/transactions/swap/contexts/SwapFormContext";
import { TestID } from "test/fixtures/testIDs";
import { isWeb } from "utilities/src/platform";
export function WarningModalContent({
  onClose,
  onReject,
  onAcknowledge,
  modalName,
  title,
  titleComponent,
  caption,
  captionComponent,
  rejectText,
  acknowledgeText,
  severity = WarningSeverity.Medium,
  children,
  icon,
  hideIcon,
  maxWidth,
  hideHandlebar = false,
  backgroundIconColor,
  analyticsProperties
}) {
  const colors = useSporeColors();
  const { headerText: alertHeaderTextColor } = getAlertColor(severity);
  return <Flex
    centered
    gap="$spacing12"
    maxWidth={maxWidth}
    pb={isWeb ? "$none" : "$spacing12"}
    pt={hideHandlebar ? "$spacing24" : "$spacing12"}
    px={isWeb ? "$none" : "$spacing24"}
  >
      {!hideIcon && <Flex
    centered
    borderRadius="$rounded12"
    mb="$spacing8"
    p={backgroundIconColor === false ? "$none" : "$spacing12"}
    style={backgroundIconColor === false ? void 0 : {
      backgroundColor: backgroundIconColor ?? opacify(12, colors[alertHeaderTextColor].val)
    }}
  >
          {icon ?? <AlertTriangleFilled color={alertHeaderTextColor} size="$icon.24" />}
        </Flex>}
      {title && <Text textAlign="center" variant={isWeb ? "subheading2" : "body1"}>
          {title}
        </Text>}
      {titleComponent}
      {caption && <Text color="$neutral2" textAlign="center" variant="body3">
          {caption}
        </Text>}
      {captionComponent}
      {children}
      {(rejectText || acknowledgeText) && <Flex row alignSelf="stretch" gap="$spacing12" pt={children ? "$spacing12" : "$spacing24"}>
          {rejectText && <Trace logPress element={ElementName.BackButton} modal={modalName} properties={analyticsProperties}>
              <Button emphasis="secondary" onPress={onReject ?? onClose}>
                {rejectText}
              </Button>
            </Trace>}
          {acknowledgeText && <Trace logPress element={ElementName.Confirm} modal={modalName} properties={analyticsProperties}>
              <Button testID={TestID.Confirm} onPress={onAcknowledge}>
                {acknowledgeText}
              </Button>
            </Trace>}
        </Flex>}
    </Flex>;
}
export function WarningModal(props) {
  const { hideHandlebar, isDismissible = true, isOpen, maxWidth, modalName, onClose, zIndex } = props;
  const colors = useSporeColors();
  const swapFormContext = useContext(SwapFormContext);
  return <Modal
    backgroundColor={colors.surface1.val}
    hideHandlebar={hideHandlebar}
    isDismissible={isDismissible}
    isModalOpen={isOpen}
    maxWidth={maxWidth}
    name={modalName}
    zIndex={zIndex}
    onClose={onClose}
  >
      {swapFormContext ? (
    // When we render this modal inside the swap flow, we want to forward the context so that it's available inside the modal's Portal.
    <SwapFormContext.Provider value={swapFormContext}>
          <WarningModalContent {...props} />
        </SwapFormContext.Provider>
  ) : <WarningModalContent {...props} />}
    </Modal>;
}
